import React, { useRef, useState, useEffect} from 'react';


import "./NavBar.css";
import "../../Pages/Home.css";
import { HiMenu } from 'react-icons/hi'
import { BiArrowBack } from 'react-icons/bi'
import { ModalController, UserManager } from '../../Managers/exports';
import { takeUntil } from 'rxjs/operators';
import { AUTHENTICATION_STATUS } from '../../Constants';
import { Subject } from 'rxjs';


// add prayer request pop up
// test registration



export const NavBar = props => {

    const mobileNavRef = useRef()
    const {gotoWatch: _gotoWatch, gotoLearnMore: _gotoLearnMore, onSecureSpot: _onSecureSpot} = props
    const [mobileOpen, setMenu] = useState(false)
    const [loggedIn, setLoggedIn] = useState(false)
    const toggleMobile = () => {
        setMenu(!mobileOpen)
    }

    const closeMenu = () => {
        setMenu(false)
    }

    const gotoWatch = () => {
        closeMenu()
        _gotoWatch()
    }
   const gotoLearnMore = () => {
        closeMenu()
        _gotoLearnMore()
    }
    const onSecureSpot = () => {
        if(loggedIn){
            UserManager.logout()
            closeMenu()
        } else {
            closeMenu()
            _onSecureSpot()
        }
    }


    const gotoDonate = () => {
        ModalController.setDonateModal()
        ModalController.open()
    }

    const leaving = new Subject

    useEffect(() => {   
        UserManager.getAuthenticationStatus()
        .pipe(takeUntil(leaving))
        .subscribe(status => {

            switch(status){
                case AUTHENTICATION_STATUS.authenticated: setLoggedIn(true); break
                default: setLoggedIn(false)
                
            }
        })

        return () => leaving.next()
    }, [])

    // console.log("logged in = ", loggedIn)


    useClickOutside(mobileNavRef, closeMenu)
    return (
        <nav>
            <div className="nav-bar-outer">
                <div className="nav-left">
                    <button className="link-button" onClick={gotoLearnMore}>Learn More</button>
                    <button className="link-button" onClick={gotoWatch}>Watch</button>
                    <a href="https://itiswritten.shop/connect/" target="_blank">Resources</a>
                    <button className="link-button" onClick={gotoDonate}>Donate</button>
                </div>
                <div className="nav-right">
                    {!loggedIn && <button className="link-button" onClick={onSecureSpot}>Login</button> }
                    <button className="nav-register" onClick={onSecureSpot}>{loggedIn ? "Logout" : "Register for Free"}</button>
                </div>
            </div>

            <div className="nav-mobile-outer" >
                <div className="nav-mobile-menu-icon-1" onClick={toggleMobile}>
                    <HiMenu 
                        color="white" 
                        size={30}
                        />
                </div>

                <div
                    ref={mobileNavRef}
                    className={`nav-mobile-open-menu-container ${mobileOpen ? "nav-mobile-menu-open" : ''}`}>
                    <div onClick={toggleMobile}>
                    <BiArrowBack color="black" size={30} />
                    </div>
                    <button className="nav-register" style={{fontSize: "1.6em"}} onClick={onSecureSpot}>{loggedIn ? "Logout" : "Register"}</button>
                    <button className="link-button" onClick={onSecureSpot}>Login</button>
                    <button className="link-button" onClick={gotoLearnMore}>Learn More</button>
                    <button className="link-button" onClick={gotoWatch}>Watch</button>
                    <a href="https://itiswritten.shop/connect/" target="_blank">Resources</a>
                    <button className="link-button" onClick={gotoDonate}>Donate</button>
                    <div className="nav-mobile-divider"></div>
                    
                </div>
            </div>
        </nav>
        )
}

export const useClickOutside = (ref, callback) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                callback()
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, callback]);
}